import React from 'react';
import {IProps} from './types';
import * as S from './styles';

const IconButton:React.FC<IProps> = (props) => {

  return (
    <S.Root 
      style={props.containerStyles} 
      hoverBackgroundColor={props.hoverBackgroundColor}
      onClick={props.action}
      onMouseDown={props.actionMouseDown}
    >
      <S.CircleContainer 
        style={props.iconStyles}
      >
        {props.children}
      </S.CircleContainer>
    </S.Root>
  );
}

export default IconButton;